import { NewBillPreviewData } from "./newBillPlaceholders";
import { ReportTable } from "./newBillTypes";

export const NEW_BILL_SAMPLE_DATA: NewBillPreviewData = {
  clinicName: "VISO DENTAL CLINIC",
  clinicAddress: "No. 24, Flower Road, Colombo 07",
  clinicPhone: "011 234 5678",
  doctorName: "Dr. Mayura Gamalath",
  doctorDesignation: "Consultant Orthodontist",
  invoiceNo: "INV-1245",
  invoiceDate: "26-09-2026 | 09:30 AM",
  regNo: "J/A1/2024",
  patientName: "User Name",
  patientAge: "22",
  patientMobile: "0771234567",
  patientGender: "Female",
  subTotal: "Rs. 4500",
  lastDue: "Rs. 500",
  discount: "Rs. 200",
  netTotal: "Rs. 4800",
  card: "Rs. 2000",
  cash: "Rs. 1800",
  bankTransfer: "Rs. 500",
  balanceLabel: "current due",
  balanceAmount: "Rs. 500",
};

export const NEW_BILL_SAMPLE_TABLES: Record<string, ReportTable> = {
  treatmentTable: {
    columns: ["No", "Treatment", "Rate", "Units", "Price"],
    rows: [
      ["1", "Dental Filling", "Rs. 2500", "1", "Rs. 2500"],
      ["2", "Scaling", "Rs. 2000", "1", "Rs. 2000"],
    ],
  },
  amountTable: {
    columns: ["Description", "Amount"],
    hideHeader: true,
    rows: [
      ["Sub Total", "Rs. 4500"],
      ["Last due", "Rs. 500"],
      ["Discount", "Rs. 200"],
      ["Total", "Rs. 4800"],
      ["Card", "Rs. 2000"],
      ["Cash", "Rs. 1800"],
      ["Bank Transfer", "Rs. 500"],
      ["current due", "Rs. 500"],
    ],
  },
};

export function mergeClinicPreviewData(
  sample: NewBillPreviewData,
  clinic?: {
    clinicName?: string;
    address?: string;
    tpNo?: string;
    drName?: string;
    doctorDesignation?: string;
  }
): NewBillPreviewData {
  const looksLikePlaceholder = (value?: string) => {
    const v = String(value ?? "").trim();
    return !v || v === "clinicName" || v === "12454" || v === "0771234567" || v === "docto1 james";
  };

  const realOrSample = (value: string | undefined, fallback: string) =>
    looksLikePlaceholder(value) ? fallback : String(value).trim();

  return {
    ...sample,
    clinicName: looksLikePlaceholder(clinic?.clinicName)
      ? sample.clinicName
      : String(clinic?.clinicName).toUpperCase(),
    clinicAddress: realOrSample(clinic?.address, sample.clinicAddress),
    clinicPhone: realOrSample(clinic?.tpNo, sample.clinicPhone),
    doctorName: realOrSample(clinic?.drName, sample.doctorName),
    doctorDesignation: realOrSample(
      clinic?.doctorDesignation,
      sample.doctorDesignation
    ),
  };
}
